// extracted by mini-css-extract-plugin
export default {"invoiceHistoryTable":"InvoiceHistoryTable_invoiceHistoryTable__OrxEK"};